/**
 * @type {{NEXT_AVAILABLE_VIEW: string, FIVE_DAY_VIEW: string, TWO_WEEK_VIEW: string, DAY_VIEW: string, WEEK_VIEW: string}}
 */
export const TimesgridTypeEnum = {
    NEXT_AVAILABLE_VIEW: 'nextAvailable',
    DAY_VIEW: 'oneDay',
    FIVE_DAY_VIEW: 'fiveDays',
    WEEK_VIEW: 'oneWeek',
    TWO_WEEK_VIEW: 'twoWeeks',
};

export const WEEK_VIEW_MAX_ROW = 2;
export const WEEK_VIEW_MOBILE_MAX_DAY = 7;
export const WEEK_VIEW_DESKTOP_MAX_DAY = 14;
export const NEXT_AVAILABLE_MAX_ROW = 5;
export const NEXT_AVAILABLE_MOBILE_DEFAULT_SLOTS = 10;
export const DEFAULT_INITIAL_WEEK_VIEW_COLUMN = 7;
export const MAX_NUM_DAYS_TIMESTONE = 14;
export const TIMESTONE_SLOT_HEIGHT = 100;
export const TIMESTONE_SLOT_HEIGHT_NARROW = 32;

export const NARROW_COLUMN_GUTTER_WIDTH = 3;
export const NARROW_ROW_GUTTER_WIDTH = 5;
export const DESKTOP_SLOT_WIDTH = 44;
export const MOBILE_SLOT_WIDTH = 83;
export const MOBILE_SLOT_HEIGHT = 87;
